import { GraphQLClient } from 'graphql-request';
import { domain } from '../utils/variables';
import Cookies from '../cookies/cookies';

const endpoint = `${domain?.strapi}/graphql`;

const graphQLClient = new GraphQLClient(endpoint, {
  headers: {
    authorization: '',
  },
});

const makeGraphQuery = async (query, params = {}) => {
  const rs = Cookies.getCookie('rs');
  const newParams = { ...params };
  if (rs) {
    newParams.rs = rs;
  }
  if (rs === '0' || !rs) {
    delete newParams.rs;
  }
  const data = await graphQLClient.request(query, newParams);
  // console.log(JSON.stringify(data, undefined, 2));
  return data;
};

export default makeGraphQuery;
